import styled from 'styled-components';

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-block: ${({ theme }) => theme.spacing.xl};
  /* border: 2px solid red; */

  input,
  textarea,
  select {
    min-width: 100%;
    padding: ${({ theme }) => theme.spacing.s};
    border: 1px solid ${({ theme }) => theme.colors.grey1};
    border-radius: ${({ theme }) => theme.borderRadius};
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.grey7};
    transition:
      border-color 0.3s ease,
      box-shadow 0.3s ease;

    &:focus {
      border-color: ${({ theme }) => theme.colors.yellow5};
      box-shadow: 0 0 5px ${({ theme }) => theme.colors.yellow4};
      outline: none;
    }

    &:not(:placeholder-shown) + label,
    &:focus + label {
      top: -0.8rem;
      left: 0.5rem;
      color: ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.white};
      padding: 0 0.3rem;
    }
  }

  label {
    position: absolute;
    top: 50%;
    left: 0.5rem;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.grey5};
    pointer-events: none;
    transition: all 0.3s ease;
    background-color: transparent;
    font-weight: bold;
  }

  .detail {
    color: ${({ theme }) => theme.colors.grey4};
    margin-left: ${({ theme }) => theme.spacing.xxs};
  }

  @media screen and (max-width: 650px) {
    margin-bottom: ${({ theme }) =>
      theme.spacing.m}; /* Adjust spacing for smaller screens */
  }
`;

export const TagContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xxs};
  width: 100%;
  /* justify-content: center; */
  flex-wrap: wrap;
  /* border: 1px solid green; */
  background-color: ${({ theme }) => theme.colors.offWhite};
  padding: ${({ theme }) => theme.spacing.s};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: ${({ theme }) => theme.spacing.xl};
`;
export const EachTag = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  /* gap: ${({ theme }) => theme.spacing.m}; */
  padding: ${({ theme }) => theme.spacing.xxs};
  width: calc(50% - 4rem);
  label {
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey5};
  }
`;

export const ArrayContainer = styled.div`
  margin-block: ${({ theme }) => theme.spacing.m};
  padding-block: ${({ theme }) => theme.spacing.m};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  .mappedElements {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxs};
  }
  .inputDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.xl};
    margin-block: ${({ theme }) => theme.spacing.m};
  }
  input {
    width: 70%;
  }
  h4 {
    margin-bottom: ${({ theme }) => theme.spacing.m};
    /* border-bottom: 1px solid ${({ theme }) => theme.colors.grey}; */
    //text-transform: uppercase;
  }
`;
